import { APP_META_DESCRIPTION } from '@/constants/meta'
import { APP_URL, viemChains } from '@vaultsfyi/common/constants'
import type { SupportedNetworkId } from '@vaultsfyi/common/types'
import { NETWORKS } from '@vaultsfyi/common/types'
import { http, type Config, type Transport, cookieStorage, createConfig, createStorage, fallback } from 'wagmi'
import type { Chain } from 'wagmi/chains'
import { coinbaseWallet } from 'wagmi/connectors/coinbaseWallet'
import { injected } from 'wagmi/connectors/injected'
import { walletConnect } from 'wagmi/connectors/walletConnect'
import { apiRoutes } from './routes'
import { createWalletConnectStorage } from './walletConnectStorage'

const connectors = { coinbaseWallet, injected, walletConnect } as const
export type ConnectorType = (typeof connectors)[keyof typeof connectors]['type']

let wagmiConfigInstance: Config | undefined

export const getWagmiConfig = (): Config => {
  if (wagmiConfigInstance) {
    return wagmiConfigInstance
  }

  const baseUrl = typeof window !== 'undefined' ? window.location.origin : APP_URL
  const configChains = NETWORKS.map((network) => viemChains[network] as Chain) as [Chain, ...Chain[]]

  wagmiConfigInstance = createConfig({
    chains: configChains,
    connectors: [
      connectors.coinbaseWallet({
        appName: 'vaults.fyi',
        appLogoUrl: `${APP_URL}/favicon.svg`,
      }),
      connectors.injected(),
      connectors.walletConnect({
        projectId: 'cec4e73ceb25170b43bd2dbf802a7f95',
        metadata: {
          name: 'vaults.fyi',
          description: APP_META_DESCRIPTION,
          url: APP_URL,
          icons: [`${APP_URL}/favicon.svg`],
        },
        showQrModal: true,
        storage: createWalletConnectStorage(),
      }),
    ],
    transports: Object.fromEntries(
      configChains.map((chain) => {
        const rpcUrl = new URL(`${apiRoutes.apiRpc}/${chain.id}`, baseUrl).toString()
        return [chain.id, fallback([http(rpcUrl), http()])]
      })
    ) as Record<SupportedNetworkId, Transport>,
    ssr: true,
    storage: createStorage({
      storage: cookieStorage,
    }),
  })

  return wagmiConfigInstance
}
